import { selector } from "recoil";
import { userAtom } from "./State";
import { IUserProgramRolesComplianceData } from "@interfaces/Interfaces";

export type UserRole = {
  area?: string;
  programID?: string;
  programName: string;
  programRoles: Array<UserProgramRole | string>;
  team?: string;
  complianceData?: IUserProgramRolesComplianceData[];
};

export type UserProgramRole = {
  roleID: string;
  roleName: string;
  optionalStandards: Array<{ id: string; name: string }>;
};

export const userRolesSelector = selector<UserRole[]>({
  key: "userRolesSelector",
  get: ({ get }) => {
    const user = get(userAtom);

    if (user) {
      return user.programRoles ?? [];
    }

    return [];
  },
});
